/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/chess-console
 * License: MIT, see file 'LICENSE'
 */

import {Observe} from "../../../lib/cm-web-modules/observe/Observe.js"
import {UiComponent} from "../../../lib/cm-web-modules/app/Component.js"
import {COLOR} from "../../../lib/cm-chess/Chess.js"
import {DomUtils} from "../../../lib/cm-web-modules/utils/DomUtils.js"
import {get} from "svelte/store"
import {sessionData} from "../../stores.js"

export class History extends UiComponent {

    constructor(chessConsole, props) {
        super(chessConsole.context, props)
        this.chessConsole = chessConsole
        this.element = document.getElementById("history-output")
        this.props = {
            notationType: "text",
            makeClickable: false
        }
        Object.assign(this.props, props)
        this.chessConsole.state.observeChess(() => {
            this.redraw()
        })
        Observe.property(chessConsole.state, "plyViewed", () => {
            this.redraw()
        })
    }

    redraw() {
        window.clearTimeout(this.redrawDebounce)
        this.redrawDebounce = setTimeout(() => {
            const history = this.chessConsole.state.chess.history()
            let sanWhite
            let sanBlack
            let output = ""
            let i
            let rowClass = ""
            let whiteClass = ""
            let blackClass = ""
            for (i = 0; i < history.length; i += 2) {
                const moveWhite = history[i]
                if (moveWhite) {
                    sanWhite = moveWhite.san
                }
                const moveBlack = history[i + 1]
                if (moveBlack) {
                    sanBlack = moveBlack.san
                } else {
                    sanBlack = ""
                }
                if (this.chessConsole.state.plyViewed < i + 1) {
                    whiteClass = "text-muted"
                }
                if(this.chessConsole.state.plyViewed === i + 1) {
                    whiteClass = "active"
                }
                if (this.chessConsole.state.plyViewed < i + 2) {
                    blackClass = "text-muted"
                }
                if(this.chessConsole.state.plyViewed === i + 2) {
                    blackClass = "active"
                }
                output += "" + (i / 2 + 1) + ". " + sanWhite + " " + sanBlack + " "
            }
            const sessionDataValue = get(sessionData)
            sessionDataValue.history = output
            sessionData.set(sessionDataValue)
            setTimeout(() => {
                this.scrollToBottom(this.element)
            }, 100)
            /*
            if (this.chessConsole.state.plyViewed > 0) {
                const $ply = $(this.element).find('.ply' + this.chessConsole.state.plyViewed)
                if ($ply.position()) {
                    this.element.scrollTop = 0
                    this.element.scrollTop = ($ply.position().top - 68)
                }
            }
             */
        })
    }
    scrollToBottom(element) {
        element.scrollTop = element.scrollHeight;
    }
}
